import React, { useEffect, useState } from 'react'
import st from './SettingsChat.module.scss'
import { ReactComponent as NotificationIcon } from 'components/CRM/UI/icons/notification.svg'
import { BlockHeader } from 'components/UI/BlockHeader/BlockHeader'
import { ReactComponent as DeleteIcon } from 'components/UI/icons/delete-bin-6-line.svg'
import {
  EditIconButton,
  HeaderAddButton,
} from 'components/UI/SuperButton/SuperButton'
import asideModalStore from 'Stores/asideModalStore'
import useWindowWidth from '../../utils/hooks/useWindowWidth'
import styles from 'components/ContentBox/Global/ReportTable/Table.module.scss'
import { superAxiosRequest } from 'axiosApi'
import cogoToast from 'cogo-toast'
import Loader from 'components/ContentBox/Global/Loader/Loader'
import swal from 'sweetalert'
import { localisationMaster } from 'Localisation/Localisation'
import AddNewTemplates from 'components/ContentBox/Global/GlobalModalSingle/templates/CRM/AddNewTemplates/AddNewTemplates'
import ActionMenu from 'components/UI/ActionMenu/ActionMenu'
import useLocalization from 'hooks/useLocalization'
import { AutoAnsweringTemplates } from './AutoAnsweringTempalates/AutoAnsweringTemplates'
import { AnsweringTemplates } from './AnsweringTempalates/AnsweringTemplates'
import { AutoBots } from './AutoBots/AutoBots'

const SettingsChat = () => {
  const [chats, setChats] = useState([])
  const [selectedChats, setSelectedChats] = useState([])
  const windowWidth = useWindowWidth()

  const { translate } = useLocalization({
    section: 'crm',
    subsection: 'crm_event',
    dict: {
      notification_center: 'Notification Center',
      notification_center_description:
        'When this option is enabled, notifications will be sent to the Notification Center, including internal messages between employees and chats from clients',
      response_templates: 'Response templates',
      new_template: 'Add a new template',
      name: 'Name',
      reply_text: 'Reply text',
      adding_new_template: 'Adding a new template',
      save: 'Save',
      are_you_sure:
        'Are you sure you want to delete the selected {{count}} chats',
      edit_template: 'Edit template',
      update: 'Update',
    },
  })

  const fetchChats = () => {
    superAxiosRequest({
      link: `chatsdata/answerdata`,
      method: 'get',
      crm: true, // Новый домен
    })
      .then((response) => {
        setChats(response.data)
      })
      .catch(() => {})
  }

  useEffect(() => {
    fetchChats()
  }, [])

  //принимает текст и максимальную длину
  const truncateText = (text, maxLength = 100) => {
    if (text.length > maxLength) {
      return text.substring(0, maxLength) + '...'
    }
    return text
  }

  const toggleCheckbox = (chatId) => {
    const currentIndex = selectedChats.indexOf(chatId)
    const newSelectedChats = [...selectedChats]

    if (currentIndex === -1) {
      newSelectedChats.push(chatId) // Если чат не выбран, добавляем его в массив
    } else {
      newSelectedChats.splice(currentIndex, 1) // Если чат уже выбран, удаляем его из массива
    }
    setSelectedChats(newSelectedChats)
  }

  const addChat = () => {
    const ms = {
      modalBodyComponent: () => <AddNewTemplates />,
      link: 'chatsdata/answerdata',
      isResponsive: true,
      crm: true,
      title: translate.adding_new_template,
      button: translate.save,
      valid: {
        title: 'required',
        content: 'required',
      },
      onSubmitSuccess: (data) => setChats([data, ...chats]),
    }
    asideModalStore.activity(ms)
  }

  const editSelectedChat = () => {
    if (selectedChats.length !== 1) {
      cogoToast.error('Please select exactly one template to edit.')
      return
    }

    const selectedChat = chats.find((chat) => chat.id === selectedChats[0])
    if (!selectedChat) {
      cogoToast.error('Selected template not found.')
      return
    }
    const ms = {
      modalBodyComponent: () => <AddNewTemplates />,
      isResponsive: true,
      crm: true,
      title: translate.edit_template,
      button: translate.update,
      is_put: true,
      link: `chatsdata/answerdata/${selectedChat.id}`,
      onSubmitSuccess: (data) => {
        setChats(
          chats.map((chat) =>
            chat.id === data.id ? { ...chat, ...data } : chat,
          ),
        )
        // settingStore.updateSettingData({chats: data.chats})
      },
    }
    asideModalStore.activity(ms, {
      title: selectedChat.title,
      content: selectedChat.content,
    })
  }

  const deleteChat = () => {
    if (selectedChats.length === 0) {
      cogoToast.error('Please select at least one chat to delete.')
      return
    }

    swal({
      title: localisationMaster('text_2', 'alert'),
      text: translate.are_you_sure.replace('{{count}}', selectedChats.length),
      icon: 'warning',
      buttons: [
        localisationMaster('button_2', 'alert'),
        localisationMaster('button_1', 'alert'),
      ],
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        const deletePromises = selectedChats.map((chatId) => {
          const chatToDelete = chats.find((chat) => chat.id === chatId)
          const apiConf = {
            method: 'delete',
            crm: true,
            link: `chatsdata/answerdata/${chatToDelete.id}`,
          }
          return superAxiosRequest(apiConf).then(() => chatId)
        })

        Promise.all(deletePromises)
          .then((deletedChatIds) => {
            const updatedChats = chats.filter(
              (chat) => !deletedChatIds.includes(chat.id),
            )
            setChats(updatedChats)
            setSelectedChats([])
            swal(`Deleted ${deletedChatIds.length}  chats.`, {
              icon: 'success',
            })
          })
          .catch(() => {
            swal('An error occurred while deleting chats.')
          })
      } else {
        swal(localisationMaster('text_5', 'alert'))
      }
    })
  }

  const menu = [
    { name: translate.new_template, action: 'add_new_template' },
    { name: 'Delete', action: 'delete' },
    { name: 'Edit', action: 'edit' },
  ]

  const action = (action) => {
    switch (action) {
      case 'add_new_template':
        addChat()
        break
      case 'delete':
        deleteChat()
        break
      case 'edit':
        editSelectedChat()
        break
      default:
        break
    }
  }

  return (
    <div className={st.container}>
      <div className={st.settingsChatNotification}>
        <div className={st.settingsChatNotification__box}>
          {windowWidth > 425 && (
            <span>
              <NotificationIcon />
            </span>
          )}

          <div className={st.settingsChatNotification__check}>
            <span>{translate.notification_center}</span>
            <p>{translate.notification_center_description}</p>
            <label className={st.switch}>
              <input type='checkbox' />
              <span className={`${st.slider} ${st.round}`}></span>
            </label>
          </div>
        </div>
      </div>

      <div className={st.settingsChatTemplates}>
        <BlockHeader title={translate.response_templates}>
          {windowWidth < 768 ? (
            <ActionMenu menu={menu} action={action} />
          ) : (
            <div className={st.settingsChatTemplates__headBtn}>
              <EditIconButton onClick={editSelectedChat} />
              <div className={st.settingsChatTemplates__headBtnDivider}></div>
              <span className={st.settingsChatTemplates__delete}>
                <DeleteIcon onClick={deleteChat} />
              </span>
              <div className={st.settingsChatTemplates__headBtnDivider}></div>
              <HeaderAddButton
                title={translate.new_template}
                onClick={addChat}
              />
            </div>
          )}
        </BlockHeader>
      </div>
      <div className={st.settingsChatContent}>
        <div className={st.searchFilterValues}>
          {chats.length === 0 ? (
            <Loader />
          ) : (
            <table className={`${styles.table} ${styles.tbodyStriped}`}>
              <thead className={`${styles.conversionTbl} ${st.thead}`}>
                <tr>
                  <td className={`${styles.tdTotal} ${styles.tdMiddle}`}>
                    <div className={st.table__checkbox}>{translate.name}</div>
                  </td>
                  <td className={`${styles.tdTotal} ${styles.tdMiddle}`}>
                    <div className={st.table__checkbox}>
                      {translate.reply_text}
                    </div>
                  </td>
                </tr>
              </thead>
              <tbody className={styles.conversionTbl}>
                {chats.map((data) => (
                  <tr key={data.id}>
                    <td className={`${styles.tdTotal} ${styles.tdMiddle}`}>
                      <div className={st.table__checkbox}>
                        <input
                          type='checkbox'
                          onChange={() => toggleCheckbox(data.id)}
                          checked={selectedChats.includes(data.id)}
                        />
                        <span>{data.title}</span>
                      </div>
                    </td>
                    <td
                      className={`${styles.tdTotal} ${styles.bdrN} ${styles.tdMiddle} ${styles.bdlN}`}
                    >
                      <div>{truncateText(data.content)}</div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
      <AutoAnsweringTemplates />
      <AnsweringTemplates />
      <AutoBots />
    </div>
  )
}

export default SettingsChat
